export const NARRATION_MAPPING: { slug: string; en: string; hi: string }[] = [
  {
    slug: 'kyc-intro',
    en: 'You are about to begin the K Y C process. Please ensure you are in a quiet room, alone, with good lighting and a stable internet connection. You should not be wearing any dark glasses or a mask. Keep your background clean, as we want to capture some clear photos of you.',
    hi: 'आप के वाई सी प्रक्रिया शुरू करने वाले हैं। कृपया सुनिश्चित करें कि आप एक शांत कमरे में अकेले हैं, अच्छी रोशनी और स्थिर इंटरनेट कनेक्शन के साथ। आप कोई काला चश्मा या मास्क न पहनें। अपना बैकग्राउंड साफ़ रखें, क्योंकि हम आपकी कुछ स्पष्ट तस्वीरें लेना चाहते हैं।',
  },
  {
    slug: 'doc-step-intro',
    en: 'Now we will verify your I D document. Please keep it in a fixed place and ensure that the document is within the bounding box. We will capture a photo of the document.',
    hi: 'अब हम आपके पहचान डॉक्यूमेंट की पुष्टि करेंगे। कृपया इसे एक स्थिर जगह पर रखें और सुनिश्चित करें कि डॉक्यूमेंट बॉक्स के भीतर है। हम डॉक्यूमेंट की तस्वीर लेंगे।',
  },
  {
    slug: 'liveness-checking-light',
    en: 'Checking light',
    hi: 'रोशनी की जाँच हो रही है',
  },
  {
    slug: 'liveness-raise-hand',
    en: 'Raise your hand',
    hi: 'अपना हाथ उठाएँ',
  },
  {
    slug: 'liveness-ready-to-capture',
    en: 'Now, you can capture your photo',
    hi: 'अब आप अपनी तस्वीर ले सकते हैं',
  },
  {
    slug: 'selfie-intro',
    en: 'Next, we will capture a photo of you. Make sure your face is clearly visible.',
    hi: 'अब हम आपकी एक तस्वीर लेंगे। कृपया सुनिश्चित करें कि आपका चेहरा स्पष्ट रूप से दिखाई दे।',
  },
  {
    slug: 'selfie-retake-no-face',
    en: 'No face detected. Please retake with your face clearly visible.',
    hi: 'कोई चेहरा नहीं मिला। कृपया अपना चेहरा स्पष्ट दिखाकर फिर से फ़ोटो लें।',
  },
  {
    slug: 'selfie-retake-multiple-faces',
    en: 'More than one person is visible. Make sure only you are in the frame.',
    hi: 'एक से अधिक व्यक्ति दिख रहे हैं। सुनिश्चित करें कि फ़्रेम में केवल आप ही हैं।',
  },
  {
    slug: 'selfie-retake-sunglasses',
    en: 'Please remove your sunglasses and retake the photo.',
    hi: 'कृपया अपना धूप का चश्मा हटाएँ और फिर से फ़ोटो लें।',
  },
  {
    slug: 'selfie-retake-eyeglasses',
    en: 'Please remove your glasses and retake the photo.',
    hi: 'कृपया अपना चश्मा हटाएँ और फिर से फ़ोटो लें।',
  },
  {
    slug: 'selfie-retake-face-covered',
    en: 'Your face is partly covered. Remove any mask or covering and retake.',
    hi: 'आपका चेहरा आंशिक रूप से ढका है। कोई मास्क या आवरण हटाएँ और फिर से फ़ोटो लें।',
  },
  {
    slug: 'selfie-retake-eyes-closed',
    en: 'Please keep your eyes open and retake the photo.',
    hi: 'कृपया अपनी आँखें खुली रखें और फिर से फ़ोटो लें।',
  },
  {
    slug: 'selfie-retake-blurry',
    en: 'Your face looks blurry. Hold steady and retake in focus.',
    hi: 'आपका चेहरा धुंधला दिख रहा है। स्थिर रहें और फ़ोकस में फिर से फ़ोटो लें।',
  },
  {
    slug: 'selfie-retake-generic',
    en: 'Please retake with your face clearly visible.',
    hi: 'कृपया अपना चेहरा स्पष्ट दिखाकर फिर से फ़ोटो लें।',
  },
  {
    slug: 'doc-hold-steady',
    en: 'keep your hands steady during this process',
    hi: 'इस प्रक्रिया के दौरान अपने हाथ स्थिर रखें',
  },
  {
    slug: 'doc-retake-blurry',
    en: 'The document image is blurry. Please capture it again in focus.',
    hi: 'डॉक्यूमेंट की तस्वीर धुंधली है। कृपया इसे फ़ोकस में फिर से लें।',
  },
  {
    slug: 'doc-retake-invalid',
    en: 'Unable to verify the document. Please capture it again.',
    hi: 'डॉक्यूमेंट वेरिफ़ाई नहीं हो सका। कृपया इसे फिर से लें।',
  },
  {
    slug: 'surroundings-intro',
    en: 'Please capture four clear photos of the area around you.',
    hi: 'कृपया अपने आस-पास की चार साफ़ तस्वीरें लें।',
  },
  {
    slug: 'surroundings-complete',
    en: 'All four photos captured. You can submit, or re-capture if needed.',
    hi: 'चारों तस्वीरें ले ली गई हैं। आप जमा कर सकते हैं या फिर से तस्वीरें ले सकते हैं।',
  },
  {
    slug: 'question-occupation',
    en: 'What is your current occupation and how long have you been working there?',
    hi: 'आपका वर्तमान व्यवसाय क्या है और आप वहाँ कब से काम कर रहे हैं?',
  },
  {
    slug: 'question-active-loans',
    en: 'Do you have any other active loans?',
    hi: 'क्या आपके पास कोई अन्य सक्रिय ऋण है?',
  },
  {
    slug: 'kyc-end-no-report',
    en: 'Congratulations! Your K Y C verification is complete. ',
    hi: 'बधाई हो! आपका के वाई सी वेरिफ़िकेशन पूरा हो गया है। ',
  },
  {
    slug: 'kyc-end-with-report',
    en: 'Congratulations! Your K Y C verification is complete. Please provide your email address so I can send you the report.',
    hi: 'बधाई हो! आपका के वाई सी वेरिफ़िकेशन पूरा हो गया है। कृपया अपना ईमेल पता दें ताकि आपको रिपोर्ट भेजी जा सके।',
  },
]
